import { render, staticRenderFns } from "./warningList.vue?vue&type=template&id=5e3b89f8&scoped=true"
import script from "./warningList.vue?vue&type=script&lang=js"
export * from "./warningList.vue?vue&type=script&lang=js"
import style0 from "./warningList.vue?vue&type=style&index=0&id=5e3b89f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b89f8",
  null
  
)

export default component.exports